// extracted by mini-css-extract-plugin
module.exports = {"locations__list":"LocationsList_locations__list__2xN4Z"};